import { Container, Graphics, Text } from 'pixi.js';
import { Easings, tween } from '../../core/Tween';

/**
 * Compact "HOLD" badge that floats above a reel when the player has tapped to
 * hold it. Pops in (easeOutBack) on show, fades out on hide. Auto-managed by
 * {@link SlotReel} via setHeld(); the host scene controls when holds are
 * accepted (only between spins).
 */
export class HoldIndicator extends Container {
  private bg: Graphics;
  private text: Text;
  private isShown = false;

  constructor() {
    super();
    this.alpha = 0;
    this.visible = false;

    this.bg = new Graphics();
    this.bg
      .roundRect(-26, -12, 52, 24, 12)
      .fill({ color: 0xff6bd6, alpha: 0.95 })
      .stroke({ color: 0xffffff, alpha: 0.5, width: 1.5 });
    this.addChild(this.bg);

    this.text = new Text({
      text: 'HOLD',
      style: {
        fontFamily: 'system-ui, -apple-system, sans-serif',
        fontSize: 11,
        fontWeight: '900',
        fill: 0xffffff,
        letterSpacing: 2,
      },
    });
    this.text.anchor.set(0.5);
    this.addChild(this.text);
  }

  show(): void {
    if (this.isShown) return;
    this.isShown = true;
    this.visible = true;
    this.scale.set(0.6);
    tween({
      durationMs: 200,
      easing: Easings.easeOutBack,
      onUpdate: (p) => {
        this.alpha = p;
        this.scale.set(0.6 + p * 0.4);
      },
    });
  }

  hide(): void {
    if (!this.isShown) return;
    this.isShown = false;
    tween({
      durationMs: 160,
      easing: Easings.easeOutCubic,
      onUpdate: (p) => {
        this.alpha = 1 - p;
      },
      onComplete: () => {
        this.visible = false;
      },
    });
  }
}
